const defaultState = {
  requesting: false,
  error: false,
  saving: false,
  result: null,
};

export default function counter(state = defaultState, action) {
  switch (action.type) {
    case 'SUBMIT_SURVEY_REQUESTED':
      return {
        ...state,
        requesting: true,
        saving: true,
        error: false,
      }
    case 'SUBMIT_SURVEY_SUCCEEDED':
      return {
        requesting: false,
        error: false,
        saving: true,
        result: action.payload,
      }
    case 'SUBMIT_SURVEY_FAILED':
      return {
        requesting: false,
        error: true,
        saving: true,
        result: action.payload,
      }
    case 'FETCH_SURVEY_RESPONSE_REQUESTED':
      return {
        ...state,
        requesting: true,
        saving: false,
        error: false,
      }
    case 'FETCH_SURVEY_RESPONSE_SUCCEEDED':
      return {
        requesting: false,
        error: false,
        saving: false,
        result: action.payload,
      }
    case 'FETCH_SURVEY_RESPONSE_FAILED':
      return {
        requesting: false,
        error: true,
        saving: false,
        result: action.payload,
      }
    default:
      return state
  }
}
